import {
    SET_WRAPPER_ORIGIN,
    SET_WRAPPER_DEVICE_TYPE,
    SET_WRAPPER_RECIPE_SCHEMA_ITEMS,
    SET_WRAPPER_CURRENT_URL
} from '../constants/actionTypes'


export const setWrapperOrigin = origin => ({
    type: SET_WRAPPER_ORIGIN,
    origin
})

export const setWrapperDeviceType = deviceType => ({
    type: SET_WRAPPER_DEVICE_TYPE,
    deviceType
})

export const setWrapperRecipeSchemaItems = data => ({
    type: SET_WRAPPER_RECIPE_SCHEMA_ITEMS,
    data
})

export const setWrapperCurrentUrl = currentUrl => ({
    type: SET_WRAPPER_CURRENT_URL,
    currentUrl
})
